module.exports = __webpack_public_path__ + "static/media/promo_musica_criancas.878c40ba.webp";